import { useCase, useConditions } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { CaseDetailViewComponent } from "@/features/cases";

export const Route = createFileRoute("/patients/$patientId/_layout/cases/$caseId")({
  component: CaseDetailComponent,
});

function CaseDetailComponent() {
  const { patientId, caseId } = Route.useParams();
  const caseModel = useCase(caseId);
  const { conditions } = useConditions({ patientId });
  if (!caseModel) {
    return <div className="text-muted-foreground p-4">Case not found.</div>;
  }

  return (
    <CaseDetailViewComponent patientId={patientId} caseId={caseId} caseModel={caseModel} conditions={conditions} />
  );
}
